var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMagensa)?_c('credit-card-modal-magensa',_vm._g(_vm._b({},'credit-card-modal-magensa',_vm.$props,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }